var map = {
	"./all-over-print.svg": 13348,
	"./handmade.svg": 6406,
	"./no.svg": 51203,
	"./placement-print.svg": 24345,
	"./pre-made-garment.svg": 56804,
	"./printed-fabric-meters.svg": 51181,
	"./yes.svg": 35629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57352;